import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { NavMenu } from './NavMenu';
import { NavButtons } from './NavButtons';
import { dataStore } from '../stores/Context';

interface ILayout
{
	/** Текущая закладка */
	CurrentPage: number,

	/** Вложенные элементы */
	children: any
}


export const Layout: React.FC<ILayout> = observer(
	(
		// входные параметры компонента
		{ CurrentPage, children }: ILayout
	) =>
	{

		return (
			<>
				<header>
					<div className="top-bar">
						<div className="container-fluid">
							<div className="go-back">
								<a href="https://www.nalog.gov.ru/" rel="noopener noreferrer" className="d-flex align-items-center">
									<img src="./i/icons/arrow-left.svg" className="mr-2" alt="На сайт ФНС России" />
									На сайт ФНС России
								</a>
							</div>
						</div>
					</div>
					<div className="logo">
						<div className="container-fluid">
							<a href="https://www.nalog.gov.ru/" rel="noopener noreferrer">
								<img src="./i/logo.svg" alt="Заявление Оператора ЭДО" />
							</a>
						</div>
					</div>
				</header>
				<div className="main-container">
					<div className="container-fluid">
						<main className="flex-column-container">
							{CurrentPage!==0 &&
								<NavMenu CurrentPage={CurrentPage} />
							}
							{children}
						</main>
						<NavButtons CurrentPage={CurrentPage} />
					</div>
				</div>
				<footer className="main-footer fixed-footer">
					<div className="container-fluid">
						<div className="row">
							<div className="col-sm-auto">
								<div className="logo-and-contacts d-flex align-items-center align-items-md-start justify-content-center justify-content-md-start">
									<a href="https://www.nalog.gov.ru/" rel="noopener noreferrer" target="_blank"><img src="./i/footer-logo.svg" alt="Логотип ФНС" className="footer-logo" /></a>
									<div className="contacts ml-4">
										<p className="mb-1"><strong>Контакт-центр ФНС России:</strong></p>
										<p className="mb-1">8 800 222-22-22</p>
										<p className="mb-0"><a href="https://www.nalog.ru/rn77/apply_fts/" className="link" rel="noopener noreferrer" target="_blank">Все контакты</a></p>
									</div>
								</div>
							</div>
							<div className="col-sm mt-2 mt-md-0">
								<a href="https://www.nalog.gov.ru/rn77/service/service_feedback/?service=96" rel="noopener noreferrer" target="_blank" className="btn btn-light-grey btn-xs">Техническая поддержка</a>
							</div>
						</div>
						<div className="copyrights">
							<div className="row">
								<div className="col-sm-6">
									<p className="mb-2 mb-md-0 text-center text-sm-left">© 2005-{new Date().getFullYear()} ФНС России
										&nbsp;&nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;&nbsp;
										<span style={{ fontSize: "10px" }}>
											Версия &nbsp;&nbsp;
											Ф:{document.querySelector<HTMLMetaElement>('meta[name="site-version"]')?.content} &nbsp;&nbsp;
											Б:{dataStore.BackendVersion}
										</span>
									</p>
								</div>
								<div className="social mt-2 mt-sm-0 col-sm-6 d-flex align-items-center justify-content-center justify-content-sm-end">
									<a href="tel:88002222222" rel="noopener noreferrer" target="_blank">
										<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M9.23133 9.22867C7.64783 10.8107 5.81325 12.3247 5.08803 11.5997C4.0507 10.5627 3.4105 9.65867 1.12177 11.4977C-1.16595 13.3357 0.591605 14.5617 1.59692 15.5657C2.75729 16.7257 7.08266 15.6277 11.358 11.3547C15.6324 7.08067 16.7277 2.75667 15.5663 1.59667C14.561 0.590666 13.3406 -1.16533 11.5021 1.12167C9.66247 3.40867 10.5658 4.04867 11.6051 5.08667C12.3273 5.81167 10.8138 7.64567 9.23133 9.22867Z" />
										</svg>
									</a>
								</div>
							</div>
						</div>
					</div>
				</footer>
			</>
		);
	}
)
